export default __webpack_public_path__ + "static/media/logo_beta.c0deccf7.svg";